
import { FC, useState } from "react"
import './ModalStyle.scss'
import { ModalClose, OpenScenarioSvg, QuickDeploy, SimulateLogo } from "../svgs/Svgs"
import { useSelector } from "react-redux"
import { MissionStore } from "../../../store/MissionSlice"

interface DeployTypeModalProps {
    open: boolean,
    close: () => void,
    select_deploy_type: (type: string) => void,
}

const DeployTypeModal: FC<DeployTypeModalProps> = ({ open, close, select_deploy_type }) => {

    const [type, set_type] = useState<string>('simulation')
    const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);

    const close_modal = () => {
        close()
        set_type('simulation')
    }

    return (
        <div className={`deploy__model ${open && 'active'}`}>
            <div className="deploy__model__center">
                <div className="deploy__model__center__header">
                    <span className="fs-18">Deployment Mode</span>
                    <button className="header__close__button" onClick={close_modal}>
                        <ModalClose />
                    </button>
                </div>
                <div className="deploy__model__center__body">
                    <button className={`deploy__type__items ${type === 'simulation' && 'active'}`}
                        onClick={() => { set_type('simulation') }}
                        onDoubleClick={() => {
                            select_deploy_type('simulation')
                            close_modal()
                        }}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <SimulateLogo color={'#F0F0F0'} />
                            <span className="fs-16">Scenario Simulation</span>
                        </div>
                        <span className="info-msg-text opacity-75">Simulate different scenarios on a fully software-based simulation environment that mirrors the behaviour of a real satellite.</span>
                    </button>
                    <button className={`deploy__type__items ${type === 'quick_deploy' && 'active'} ${userData?.['feature-allowed']?.['hwInLoop'] === 'No' && 'disablingtab'}`}
                        onClick={() => {
                            set_type('quick_deploy')
                        }}
                        onDoubleClick={() => {
                            select_deploy_type('quick_deploy')
                            close_modal()
                        }}
                        disabled={userData?.['feature-allowed']?.['hwInLoop'] === 'No'}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <QuickDeploy />
                            <span className="fs-16">Quick Deploy</span>
                        </div>
                        <span className="info-msg-text opacity-75">
                            Quick Deploy creation enables testing of satellite components by integrating physical hardware with high-fidelity simulation environments.
                        </span>
                    </button>
                    <button className={`deploy__type__items ${type === 'open_scenario' && 'active'} ${userData?.['feature-allowed']?.['trueTwinCommandCenter'] !== 'Yes' && 'disablingtab'}`}
                        onClick={() => {
                            set_type('open_scenario')
                        }}
                        onDoubleClick={() => {
                            select_deploy_type('open_scenario')
                            close_modal()
                        }}
                        disabled={userData?.['feature-allowed']?.['trueTwinCommandCenter'] !== 'Yes'}
                    >
                        <div className="d-flex align-items-center gap-2">
                            <OpenScenarioSvg />
                            <span className="fs-16">TrueTwin Command Center</span>
                        </div>
                        <span className="info-msg-text opacity-75">
                            Execute scenarios that mirror real-time satellite operation experience with tasks such as uploading schedule, performing system updates, etc.
                        </span>
                    </button>
                </div>
                <div className="deploy__model__center__footer">
                    <button className="footer__close__button" onClick={close_modal}>
                        Close
                    </button>
                    <button className={`footer__next__button ${type ? '' : 'disable'}`} onClick={() => {
                        if (type) {
                            select_deploy_type(type)
                            close_modal()
                        }
                    }}>
                        Next
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeployTypeModal